import substack from './substack.json';

import './Writing.css';

const NoteTitle = ({ context: { type, timestamp } }) => {
	const shortDate = (new Date(timestamp)).toLocaleDateString();
	const dayOfWeek = new Intl.DateTimeFormat("en-US", { weekday: "long" }).format(new Date(timestamp));
	return <p><sup>{type}</sup>{dayOfWeek}<sub>{shortDate}</sub></p>;
};

const Writing = () => (
  <div id="Writings">
		<h2>Writings</h2>
		<div className="notes">
			{substack.items.map(({entity_key, context, comment: {body}}) =>
				<fieldset key={entity_key}>
					<legend><NoteTitle context={context} /></legend>
					<p>{body}</p>
				</fieldset>
			)}
		</div>
		<div id="FavCreators">
			<a href="https://substack.com">a person</a>
		</div>
  </div>
);

export default Writing;
